






















import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { StringFilterParameter } from ".";
import { ImelessTextarea } from "..";
import { BrowserKinds, BrowserUtility } from "../../../utilities";

@Component({
  components: {
    ImelessTextarea,
  },
})
export default class StringFilter extends Mixins(ModelEditableMixin) {
  editingSource: StringFilterParameter;

  data(): any {
    return {
      imelessKeyword: "",
    };
  }
  imelessKeyword: string;

  @Prop({ default: false })
  shouldActiveIme: boolean;

  @Prop({ default: false })
  shouldInactiveIme: boolean;

  @Prop({ default: false })
  shouldDisableIme: boolean;

  get isIe(): boolean {
    return (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer);
  }

  get shouldUseImelessTextarea(): boolean {
    return !this.shouldActiveIme && !this.shouldInactiveIme && this.shouldDisableIme && !this.isIe;
  }

  get inputStyleProperties(): any {
    return {
      imeMode: this.getImeModeText(),
    };
  }

  getImeModeText(): string {
    if (this.shouldActiveIme) { return "active"; }
    if (this.shouldInactiveIme) { return "inactive"; }
    if (this.shouldDisableIme) { return "disabled"; }
    return "auto";
  }

  focus(): void {
    if (this.shouldUseImelessTextarea) {
      const editor = this.$refs.imelessTextarea as ImelessTextarea;
      editor.focusToEditor();
    } else {
      const element = this.$refs.input as HTMLInputElement;
      element.focus();
    }
  }

  get keyword(): string {
    return this.editingSource.keyword;
  }

  set keyword(source: string) {
    if (this.keyword !== source) {
      this.writeProperty(s => s.keyword = source);
    }
  }

  onblur(target: HTMLInputElement | HTMLTextAreaElement): void {
    // changeイベント(v-model.lazy)ではkeywordの更新が発生しない場合があるための対応
    // 具体的にはEnterでkeywordを変えた場合、その後のデータが反映されない模様
    if (this.keyword !== target.value) {
      this.keyword = target.value;
    }
    this.emitBlur();
  }

  @Emit("onEnterText")
  onEnterText(target: HTMLInputElement | HTMLTextAreaElement): void {
    if (this.keyword !== target.value) {
      this.keyword = target.value;
    }
  }

  @Emit("onMouseDown")
  emitMouseDown(): void {}

  @Emit("onBlur")
  emitBlur(): void {}

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: StringFilterParameter) {
    if (this.shouldUseImelessTextarea && !!newValue) {
      this.imelessKeyword = newValue.keyword;
    }
  }
}
